/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestLiquityHintHelper extends Contract<ITestLiquityHintHelper> {
  getApproxHint: Send<(_CR: BigNumberish, _numTrials: BigNumberish, _inputRandomSeed: BigNumberish) => { hintAddress_: string, diff_: BigNumber, latestRandomSeed_: BigNumber }, ITestLiquityHintHelper>
  'getApproxHint(uint256,uint256,uint256)': Send<(_CR: BigNumberish, _numTrials: BigNumberish, _inputRandomSeed: BigNumberish) => { hintAddress_: string, diff_: BigNumber, latestRandomSeed_: BigNumber }, ITestLiquityHintHelper>
}

let ITestLiquityHintHelperBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestLiquityHintHelperBytecode = '0x';
}

// prettier-ignore
export const ITestLiquityHintHelper = contract<ITestLiquityHintHelper>(ITestLiquityHintHelperBytecode)`
  function getApproxHint(uint256 _CR, uint256 _numTrials, uint256 _inputRandomSeed) returns (address hintAddress_, uint256 diff_, uint256 latestRandomSeed_)
`;